export default __webpack_public_path__ + "static/media/gallery_01.07c1052f.jpg";